// extracted by mini-css-extract-plugin
export var cardContainer = "_r0-0";
export var cardHeader = "_r0-2";
export var collapsedState = "_r0-3";
export var dragHandle = "_r0-5";
export var dragHandleIcon = "_r0-6";
export var dragging = "_r0-1";
export var titleArea = "_r0-4";